import { render, staticRenderFns } from "./ClockComponent.vue?vue&type=template&id=2827e33e&scoped=true&"
import script from "./ClockComponent.vue?vue&type=script&lang=js&"
export * from "./ClockComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClockComponent.vue?vue&type=style&index=0&id=2827e33e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827e33e",
  null
  
)

export default component.exports